import { createAction } from '@reduxjs/toolkit';

type ToastSeverity = 'error' | 'info' | 'success' | 'warning';

export interface ToastConfig {
  message: string | null;
  severity: ToastSeverity | null;
  details?: { [key: string]: unknown } | null;
}

export const setToast = createAction<ToastConfig>('metaData/setToast');
